<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted user column -->
      <template #cell(user)="data">
        <display-user :user="data.value" />
      </template>
      <!-- A custom formatted type column -->
      <template #cell(type)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_type"
        />
      </template>
      <!-- A custom formatted amount column -->
      <template #cell(amount)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted status column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no affiliates to display") }}
      </h6>
    </div>
  </div>
</template>

<script>

import { ListTable } from '../../../common/mixins/list'

export default {
  name: 'AffiliatesList',
  mixins: [ListTable],
  data() {
    return {
      routeName: 'affiliates',
    }
  },
}
</script>

<style scoped>

</style>
